import { render, staticRenderFns } from "./GroupDetails.vue?vue&type=template&id=78635b16"
import script from "./GroupDetails.vue?vue&type=script&lang=ts"
export * from "./GroupDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports